<template>
  <div class="course-about">
    <div class="row">
      <div class="col-lg-4">
        <div
          class="course-cover mb-3"
          :style="`background-image: url(${course.cover})`"
        />
      </div>
      <div class="col-lg-8">
        <h2 class="mb-3">Sobre o curso</h2>
        <div class="mb-4" v-html="course.short_description"></div>
        <p v-if="blocked" class="mb-5">
          <s v-if="course.discount">R$ {{ normalPrice }}</s>
          R$ {{ finalPrice }}
        </p>
        <div class="d-flex" v-if="!hideButton">
          <button
            v-if="blocked && buttonToBuy"
            href="#"
            class="btn btn-dark px-4 font-weight-bold"
            @click="buy"
          >
            Comprar
          </button>
          <router-link
            v-else-if="blocked"
            :to="{ name: 'course-details', params: { ...course } }"
            class="btn btn-success px-4 font-weight-bold"
          >
            Detalhes
          </router-link>
          <router-link
            v-else
            class="btn btn-primary font-weight-bold px-4"
            :to="{ name: 'course-lessons', params: { ...course } }"
          >
            Acessar
            <i class="icon-arrow-right ml-2"></i>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatMoney } from "@/functions/helpers.js";
import get from "lodash/get";

export default {
  props: {
    hideButton: {
      type: Boolean,
      default: false
    },
    course: {
      type: Object,
      default: () => ({})
    },
    buttonToBuy: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    checkoutUrl() {
      const customLink = get(this.course, "product.purchase_url");
      return customLink
        ? customLink
        : `https://pay.seminariodefilosofia.org/${get(
            this.course,
            "product.prod_id"
          )}`;
    },
    blocked() {
      return !this.$user.myCourses[this.course.id];
    },
    normalPrice() {
      return formatMoney(parseFloat(get(this.course, "product.price_card", 0)));
    },
    finalPrice() {
      return formatMoney(
        parseFloat(get(this.course, "product.price_card", 0)) -
          parseFloat(get(this.course, "product.discount", 0) || 0)
      );
    }
  },
  methods: {
    buy() {
      window.open(this.checkoutUrl);
    }
  }
};
</script>

<style lang="scss" scoped>
.course-about {
  img {
    width: 100%;
  }

  ::v-deep p {
    font-size: 16px;
    line-height: 24px;
    color: #979797;
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    color: white !important;
  }
}
</style>
